/**
 * Decides whether the social-feed FX debug panel is visible.
 *
 * - Never in production.
 * - Local dev (`NODE_ENV === 'development'`) → on by default, regardless of
 *   `NEXT_PUBLIC_ENV` (which is set to `staging` in `.env.local` — same
 *   reading as isInventoryDebugEnabled).
 * - Deployed staging / preview → per-user opt-in via `?fxdebug=1` ONLY.
 *
 * Mirrors isInventoryDebugEnabled deliberately: a shared staging env var once
 * showed the inventory debug pill to CLIENTS testing on staging. A query
 * param is per-session and safe, so this panel adopts the same contract from
 * day one. This is the panel-visibility belt; the read-site belt is
 * useSocialCurrencyOverride's hard null in production.
 */
export function isSocialFxDebugEnabled(params: {
  env: string | undefined
  nodeEnv: string | undefined
  fxdebugParam: string | null
}): boolean {
  const { env, nodeEnv, fxdebugParam } = params
  if (env === 'production') return false
  if (nodeEnv === 'development') return true
  return fxdebugParam === '1'
}
